import React from "react";

const TIME_LABELS = {
  morning:   "Morning",
  midday:    "Midday",
  afternoon: "Afternoon",
  evening:   "Evening",
  night:     "Night",
  weekly:    "Weekly",
  other:     "Other",
};

function RoutineCard({ routine }) {
  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <h3 style={styles.title}>{routine.title}</h3>
        <span style={styles.timeBadge}>
          {TIME_LABELS[routine.time_of_day] || routine.time_of_day}
        </span>
      </div>

      {routine.steps?.length > 0 && (
        <ol style={styles.steps}>
          {routine.steps.map((step, i) => (
            <li key={i} style={styles.step}>
              <span style={styles.stepText}>{step.text}</span>
              {step.notes && (
                <span style={styles.stepNote}>{step.notes}</span>
              )}
            </li>
          ))}
        </ol>
      )}

      {routine.transition_notes && (
        <div style={styles.transition}>
          <span style={styles.transitionLabel}>Transitions</span>
          <p style={styles.transitionText}>{routine.transition_notes}</p>
        </div>
      )}
    </div>
  );
}

export default function RoutineList({ routines = [] }) {
  if (!routines.length) return null;
  return (
    <div style={styles.list}>
      {routines.map(r => <RoutineCard key={r.id} routine={r} />)}
    </div>
  );
}

const styles = {
  list: { display: "flex", flexDirection: "column", gap: "var(--space-5)" },
  card: {
    background: "var(--color-surface)",
    border: "1px solid var(--color-border)",
    borderRadius: "var(--radius-lg)",
    padding: "var(--space-6)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-5)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "var(--space-4)",
  },
  title: {
    fontSize: "var(--text-base)",
    fontWeight: "var(--weight-semibold)",
    color: "var(--color-text-primary)",
  },
  timeBadge: {
    fontSize: "var(--text-xs)",
    fontWeight: "var(--weight-medium)",
    color: "var(--color-accent)",
    background: "var(--color-accent-subtle)",
    borderRadius: "var(--radius-full)",
    padding: "2px var(--space-3)",
    whiteSpace: "nowrap",
  },
  steps: {
    paddingLeft: "var(--space-5)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-3)",
  },
  step: {
    fontSize: "var(--text-sm)",
    color: "var(--color-text-secondary)",
    lineHeight: "var(--leading-normal)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  },
  stepText: { color: "var(--color-text-secondary)" },
  stepNote: {
    fontSize: "var(--text-xs)",
    color: "var(--color-text-tertiary)",
    fontStyle: "italic",
  },
  transition: {
    background: "var(--color-bg-subtle)",
    borderRadius: "var(--radius-md)",
    padding: "var(--space-4)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  },
  transitionLabel: {
    fontSize: "var(--text-xs)",
    fontWeight: "var(--weight-semibold)",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    color: "var(--color-text-tertiary)",
  },
  transitionText: {
    fontSize: "var(--text-sm)",
    color: "var(--color-text-secondary)",
    lineHeight: "var(--leading-normal)",
  },
};
